import { Clipboard } from '@capacitor/clipboard'

export async function copyToClipboard(text: string): Promise<void> {
  await Clipboard.write({ string: text })
}
